export const getTypeDisplayName = type => {
  switch (type) {
    case 'Text':
      return 'Short Text'
    default:
      return type
  }
}

export const whiteListedTypesForCalculation = [
  'Number',
  'Rating',
  'Decimal',
  'Sum',
  'Date',
  'Time',
  'Calculation',
]
